<template>
  <div class="toggler-language">
    <UiText
      class="toggler-language__desciption"
      font="body-heading-4"
      color="form-label-text-color"
      :text="$tc('footer.language.text')"
    />
    <UiTabs
      ref="tabsRef"
      :tabs="tabsList"
      :value="activeTab"
      :query="false"
      theme="lighten"
      size="s"
      @input="changeTab"
    />
  </div>
</template>

<script>
import UiTabs from '@/components/ui/UiTabs'

export default {
  name: 'FooterTogglerLanguage',
  components: {
    UiTabs,
  },
  computed: {
    activeTab() {
      return this.$i18n.locale
    },
    tabsList() {
      return [
        {
          id: 'ua',
          title: this.$t('footer.language.ua'),
        },
        {
          id: 'ru',
          title: this.$t('footer.language.ru'),
        },
      ]
    },
  },
  methods: {
    changeTab(value) {
      console.log(this.switchLocalePath(value))
      this.setLang(value)
      this.$router.push(this.switchLocalePath(value))
    },
    setLang(lang) {
      if (this.switchLocalePath(lang) === '') {
        this.$i18n.setLocale(lang)
      }
      this.$store.commit('user/setLang', lang)
    },
  },
}
</script>

<style lang="scss" scoped src="./style.scss"></style>
